<template>
    <div>
        <div class="container pb-5">
            <!-- Placeholder -->
            <div v-if="!isPostLoaded">
                <div class="placeholder">
                    <div class="post-cover"></div>

                    <!-- Title -->
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10">
                            <div class="page-title mt-4 mt-lg-5 mb-3"></div>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="row">
                                <div class="col">
                                    <div class="paragraph" style="width: 35%;"></div>
                                    <div class="paragraph" style="width: 45%;"></div>
                                </div>
                                <div class="col d-flex justify-content-end align-items-center">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="row justify-content-center justify-content-lg-end mt-5">
                        <div class="col-12 col-md-10 col-lg-8">
                            <div class="paragraph mb-3" style="width: 100%;"></div>
                            <div class="paragraph mb-3" style="width: 100%;"></div>
                            <div class="paragraph" style="width: 80%;"></div>
                        </div>
                        <div class="col-12 col-md-3"></div>
                    </div>
                </div>
                <!-- /.placeholder -->
            </div>
            <!-- /Placeholder -->
            <div v-if="isPostLoaded">
                <div class="post-cover" v-if="post._embedded" v-lazy-container="{ selector: 'img' }">
                    <img :data-src="post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url" :data-srcset="`${post._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url} 2x`" :alt="post._embedded['wp:featuredmedia'][0].alt_text" class="img-fluid w-100">
                </div>
                <!-- /.post-cover -->

                <!-- Title -->
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-10">
                        <h1 class="page-title mt-4 mt-lg-5 mb-3" v-html="post.title.rendered"></h1>
                    </div>
                    <div class="col-12 col-lg-10">
                        <div class="row">
                            <div class="col">
                                <p class="my-0" v-html="post.acf.event_location" v-if="post.acf.event_location"></p>
                                <p class="my-0 text-muted" v-html="post.acf.event_schedule" v-if="post.acf.event_schedule"></p>
                            </div>
                            <div class="col d-flex justify-content-end align-items-center">
                                <social-sharing :url="post.link"
                                    :title="post.title.rendered"
                                    :description="post.excerpt.rendered"
                                    inline-template
                                    network-tag="li"
                                >
                                    <ul class="nav">
                                        <network network="facebook">
                                            <span class="icon facebook">Facebook</span>
                                        </network>
                                        <network network="twitter">
                                            <span class="ml-4 icon twitter">Twitter</span>
                                        </network>
                                    </ul>
                                </social-sharing>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Content -->
                <div class="row justify-content-center justify-content-lg-end">
                    <div class="col-12 col-lg-11">
                        <div class="separate"></div>
                    </div>
                    <div class="col-12"></div>
                    <div class="col-12 col-md-10 col-lg-8">
                        <div class="page-content" v-html="post.content.rendered"></div>
                    </div>
                    <div class="col-12 col-md-3 d-none d-lg-block">
                        <div class="recent-event" v-if="isRecentPostsLoaded">
                            <h1 class="text-uppercase text-center">Recent Event</h1>
                            <ul class="recent-post">
                                <li v-for="(event, key) in recentPosts" :key="key">
                                    <router-link :to="{ name: event.post_type, params: { slug: event.slug } }">
                                        <p class="post-schedule" v-html="event.acf.event_schedule"></p>
                                        <p class="post-title" v-html="event.title.rendered"></p>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div v-if="post.acf">
                    <div class="row mb-3" v-if="post.acf.related_posts">
                        <div class="col-12"><div class="separate"></div></div>
                        <div class="col-12"><h1 class="page-title text-center my-4">กิจกรรมที่คุณอาจสนใจ</h1></div>
                        <div class="col-12 col-md-4" v-for="(related, key) in post.acf.related_posts" :key="key">
                            <router-link :to="{ name: related.post_type, params: { slug: related.post_name } }">
                                <div class="blog-article">
                                    <div class="thumbnail">
                                        <div class="thumbnail-media" v-lazy-container="{ selector: 'img' }">
                                            <img :data-src="`${related.post_thumbnail_md}`" :data-srcset="`${related.post_thumbnail_lg} 2x`" class="d-block m-auto" />
                                        </div>
                                        <!-- /.thumbnail-media -->
                                    </div>
                                    <!-- /.thumbnail -->
                                    <div class="blog-desc">
                                    <div class="category">กิจกรรม</div>
                                    <div class="description" v-html="related.post_title"></div>
                                    </div>
                                    <!-- /.blog-desc -->
                                </div>
                                <!-- /.blog-article -->
                            </router-link>
                        </div>
                    </div>
                    <!-- /.row -->
                </div>
            </div>
        </div>
        <!-- /.container -->
    </div>
</template>

<script>
import axios from 'axios'
import JQuery from 'jquery'
const Flickity = require('flickity')
export default {
  name: 'EventDetail',
  data () {
    return {
      title: process.env.VUE_APP_TITLE,
      api_path: process.env.VUE_APP_API_PATH,
      post: [],
      isPostLoaded: false,
      recentPosts: [],
      isRecentPostsLoaded: false
    }
  },
  mounted () {
    this.getPost()
    this.getRecentPosts()
  },
  methods: {
    getPost () {
      const slug = this.$route.params.slug
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isPostLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/event/`, {
        params: {
          _embed: true,
          slug,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.isPostLoaded = true
            $vm.post = res.data[0]
            document.title = `${$vm.post.title.rendered} - ${$vm.title}`
            const $ = JQuery
            setTimeout(() => {
              if ($('.has-carousel')) {
                $('.has-carousel').each(function (i) {
                  var options = JSON.parse($(this).attr('data-flickity'))
                  const carousel = new Flickity($('.has-carousel')[i], options)
                  if (carousel) {}
                })
              }
            }, 100)
          }
        })
    },
    getRecentPosts () {
      const lang = this.$route.params.lang
      const $vm = this
      $vm.isPostLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/event`, {
        params: {
          lang,
          per_page: 5
        }
      })
        .then(res => {
          if (res.data) {
            $vm.isRecentPostsLoaded = true
            $vm.recentPosts = res.data
          }
        })
    }
  },
  watch: {
    '$route' () {
      this.getPost()
      this.getRecentPosts()
    }
  }
}
</script>

<style lang="sass" scoped>
.post-cover
  margin-bottom: 1rem
</style>
